<template lang="html">
  <div class="notifications-wrapper">
    <div class="table-wrapper">
      <table v-if="notifications.length > 0">
        <thead>
          <tr>
            <td style="width: 100px;">{{ $t('main.name') }}</td>
            <td></td>
            <td style="width: 140px;">{{ $t('profile.purchase.date') }}</td>
            <td style="width: 40px;"></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="notification in notifications">
            <tr
              :class="{ seen: notification.msg_read === 1 }"
              @click="
                seeNotification(notification),
                  (notification.open = !notification.open),
                  (notification.msg_read = 1)
              "
              :key="notification.msg_id"
            >
              <td>{{ notification.usr_name }}</td>
              <td>
                <div
                  v-html="generateMessage(notification.msg_message)"
                  class="overflow-td"
                ></div>
              </td>
              <td>{{ notification.msg_date | moment('DD.MM.YYYY') }}</td>
              <td @click="deleteNotification(notification.msg_id, $event)">
                <img src="@/assets/icons/trash.png" alt="trash icon" />
              </td>
            </tr>
            <tr
              class="dropdown-row"
              :key="notification.msg_id + 'd'"
              :class="{ active: notification.open }"
            >
              <td colspan="100%">
                <div class="dropdown">
                  <single-notification
                    v-if="notification.open"
                    :notification="notification.msg_id"
                  />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div v-else class="no-data">
        {{ $t('profile.notifications.noNotifications') }}
      </div>
      <div v-if="notifications.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import SingleNotification from '@/components/profile/notification.vue'
export default {
  name: 'notifications',
  components: {
    SingleNotification,
    Paginate
  },
  data () {
    return {
      notifications: [],
      activeNotification: null,
      page: 1,
      pageCount: 0
    }
  },
  mounted () {
    this.getNotifications()
    eventBus.$on('refreshNotifications', () => {
      this.getNotifications()
    })
  },
  activated () {
    this.getNotifications()
  },
  methods: {
    deleteNotification (id, e) {
      e.stopPropagation()
      console.log(id)
      api
        .deleteNotification(id)
        .then(() => {
          this.getNotifications()
        })
        .catch(e => {
          console.log(e)
        })
    },
    async seeNotification (notification) {
      let params = {
        id: notification.msg_id
      }
      await api.seenUserNotification(params).catch(e => {
        console.log(e)
      })
      await api.getNotificationsCount().then(res => {
        this.$store.commit('setNotificationCounters', res.data)
      })
    },
    getNotifications () {
      let params = {
        page: this.page
      }
      api
        .getNotifications(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false
          }
          this.notifications = res.data.data
          this.pageCount = res.data.page_count
        })
        .catch(e => {
          console.log(e)
        })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
    },
    getDate (date) {
      return this.$moment(date).format('DD.MM.YYYY HH:mm')
    }
  },
  computed: {
    generateMessage () {
      return notification => {
        if (notification.type === 'new') {
          return this.$t('profile.notifications.new', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id
          })
        }
        if (notification.type === 'new-buyer') {
          return this.$t('profile.notifications.new-buyer', {
            name: notification.pro_name,
            id: notification.off_id,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'sold-out') {
          return this.$t('profile.notifications.sold-out', {
            name: notification.pro_name
          })
        }
        if (notification.type === 'reject-buyer') {
          return this.$t('profile.notifications.reject-buyer', {
            username: notification.seller_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'reject-seller') {
          return this.$t('profile.notifications.reject-seller', {
            username: notification.buyer_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'rating') {
          return this.$t('profile.notifications.rating', {
            comment: notification.comment,
            rating: notification.rating,
            username: notification.usr_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'near-exp-seller') {
          return this.$t('profile.notifications.near-exp-seller', {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            rules:
              window.location.origin + '/' + this.$route.params.lang + '/rules'
          })
        }
        if (notification.type === 'near-exp-buyer') {
          return this.$t('profile.notifications.near-exp-buyer', {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-seller-sold-out') {
          return this.$t('profile.notifications.expired-seller-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-seller-price') {
          return this.$t('profile.notifications.expired-seller-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            offCount: notification.off_count
          })
        }
        if (notification.type === 'expired-seller-no-buyers') {
          return this.$t('profile.notifications.expired-seller-no-buyers', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-buyer-sold-out') {
          return this.$t('profile.notifications.expired-buyer-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id
          })
        }
        if (notification.type === 'expired-buyer-price') {
          return this.$t('profile.notifications.expired-buyer-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id,
            mun_unit: notification.mun_unit
          })
        }
        if (notification.type === 'expired-buyer-unsold') {
          return this.$t('profile.notifications.expired-buyer-unsold', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'seller-gave-up') {
          return this.$t('profile.notifications.seller-gave-up', {
            username: notification.seller_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'new-product-admin') {
          return this.$t('profile.notifications.new-product-admin', {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'three-day-seller') {
          return this.$t('profile.notifications.three-day-seller', {
            username: localStorage.getItem('userName'),
            name: notification.pro_name,
            date: this.getDate(notification.pro_expiry),
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'renew-product') {
          return this.$t('profile.notifications.renew-product', {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'admin-deleted') {
          return this.$t('profile.notifications.admin-deleted', {
            name: notification.pro_name
          })
        }
        if (notification.type === 'admin-rating') {
          return this.$t('profile.notifications.admin-rating', {
            comment: notification.comment,
            rating: notification.rating,
            usernameFrom: notification.usr_username_from,
            usernameTo: notification.usr_username_to
          })
        }
        if (notification.type === 'removed-product-admin') {
          return this.$t('profile.notifications.removed-product-admin', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            username: notification.usr_username
          })
        }
        if (notification.type === 'offer-edit') {
          return this.$t('profile.notifications.offer-edit', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price
          })
        }
        if (
          notification.type === 'three-day-admin' ||
          notification.type === 'near-exp-admin'
        ) {
          return this.$t('profile.notifications.three-day-admin', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            date: this.getDate(notification.pro_expiry)
          })
        }
        if (notification.type === 'expired-admin-price') {
          return this.$t('profile.notifications.expired-admin-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            offCount: notification.off_count
          })
        }
        if (notification.type === 'expired-admin-no-buyers') {
          return this.$t('profile.notifications.expired-admin-no-buyers', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-admin-sold-out') {
          return this.$t('profile.notifications.expired-admin-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'new-user-admin') {
          return this.$t('profile.notifications.new-user-admin', {
            cnt_name: notification.cnt_name,
            org_contact: notification.org_contact,
            org_id: notification.org_id,
            org_pib: notification.org_pib,
            osr_name: notification.osr_name,
            otp_name: notification.otp_name,
            type: notification.type,
            usr_address: notification.usr_address,
            usr_email: notification.usr_email,
            usr_name: notification.usr_name,
            usr_phone_number: notification.usr_phone_number,
            usr_postal_code: notification.usr_postal_code,
            usr_region: notification.usr_region,
            usr_username: notification.usr_username
          })
        }
        if (notification.type === 'seller-changed') {
          return this.$t('profile.notifications.seller-changed', {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          })
        }
        if (notification.type === 'buyer-changed') {
          return this.$t('profile.notifications.buyer-changed', {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          })
        }
        return notification.type
      }
    }
  },
  watch: {
    page: {
      handler () {
        this.getNotifications()
      }
    }
  },
  destroyed () {
    eventBus.$off('refreshNotifications')
  },
  deactivated () {
    eventBus.$off('refreshNotifications')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tableStyles.scss';
.notifications-wrapper {
  .dropdown-row {
    td {
      border-bottom: 1px solid #e8e8e8;
      height: 0px;
      padding: 0px;
      overflow: hidden;
      transition-duration: 0.3s;
      background: white;

      .dropdown {
        height: 0px;
        transition-duration: 0.3s;
      }
    }
  }
  .dropdown-row.active {
    cursor: default;
    td {
      border-bottom: none;
      height: auto;
      padding: 20px 20px 20px 20px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: auto;
        transition-duration: 0.3s;
        border: 1px solid rgba(243, 243, 243, 0.7);
        box-sizing: border-box;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
        padding: 20px;

        .info {
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;

          .info-key {
            font-weight: normal;
            font-size: 13px;
            line-height: 21px;
            color: #787878;
            margin-right: 10px;
            white-space: nowrap;
          }
          .info-value {
            font-weight: 800;
            font-size: 13px;
            line-height: 21px;
            letter-spacing: 0.02em;
            color: $text-color;
          }
        }
        .dropdown-header {
          display: flex;
          justify-content: space-between;

          .header {
            font-weight: bold;
            font-size: 17px;
            line-height: 28px;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }
          div {
            margin-bottom: 15px;
          }
        }
        .info-wrapper {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          position: relative;
          margin-bottom: 15px;

          .left {
            width: calc(50% - 20px);
          }
          .right {
            width: calc(50% - 20px);
          }
          textarea {
            flex-grow: 1;
            resize: none;
          }
        }
        .rate-wrapper {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  tr.deleted td {
    background: rgba(196, 196, 196, 0.15);
  }
  tr td:last-child {
    border-right: 1px solid #e8e8e8;
  }
  tbody tr td {
    border-bottom: none;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    background: rgba(196, 196, 196, 0.15);
  }
  tbody tr.seen td {
    background: white;
  }
  tbody tr {
    cursor: pointer;
  }
  tbody tr td .overflow-td {
    max-height: 60px;
    overflow: hidden;
    line-height: 60px;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
  }
  tbody tr td .overflow-td a {
    text-decoration: none !important;
  }
  .actions-wrapper {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
    .btn {
      width: 170px;
    }
  }
}
</style>
<style>
tbody tr td .overflow-td a {
  /* text-decoration: none !important; */
  color: #606060;
}
</style>
